import { atom } from "jotai";

const DraggableAtom = atom<string | undefined>(undefined);

export { DraggableAtom };
